import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6801008"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "result-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-head" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "col-title" }, "标题"),
  /*#__PURE__*/_createElementVNode("span", { class: "col-time" }, "记录时间")
], -1))
const _hoisted_3 = { class: "table-body" }
const _hoisted_4 = {
  key: 0,
  class: "empty-tip"
}
const _hoisted_5 = {
  key: 1,
  class: "empty-tip"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "col-title" }
const _hoisted_8 = { class: "col-time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "加载中..."))
        : (_ctx.list.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "暂无回测记录"))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.list, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.taskID,
                class: "table-row",
                onClick: ($event: any) => (_ctx.goDetail(item))
              }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatTitle(item)), 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.formatTime(item.backTestTime)), 1)
              ], 8, _hoisted_6))
            }), 128))
    ])
  ]))
}